module.exports = __webpack_public_path__ + "static/media/serviceindex.66dcbd2b.webp";